import { getRetrospectiveCardDocumentById } from './cards';
import { ActionItem, Card } from '../@types/domain';
import { arrayUnion, updateDoc } from 'firebase/firestore';

export const addActionItem = async (
  retrospectiveId: string,
  cardId: string,
  newActionItem
) => {
  await updateDoc(getRetrospectiveCardDocumentById(retrospectiveId, cardId), {
    actionItems: arrayUnion(newActionItem),
  });
};

export const deleteActionItem = async (
  retrospectiveId: string,
  card: Card,
  actionItemIndex: number
) => {
  card.actionItems.splice(actionItemIndex, 1);

  const cardReference =
    card.ref || getRetrospectiveCardDocumentById(retrospectiveId, card.id);

  return await updateDoc(cardReference, {
    actionItems: [...card.actionItems],
  });
};

export const updateActionItem = async (
  retrospectiveId: string,
  card: Card,
  actionItemIndex: number,
  actionItem: Pick<ActionItem, 'text'>
): Promise<void> => {
  card.actionItems[actionItemIndex].text = actionItem.text;

  const cardReference =
    card.ref || getRetrospectiveCardDocumentById(retrospectiveId, card.id);

  return await updateDoc(cardReference, {
    actionItems: [...card.actionItems],
  });
};
